import URL from './url'
import {get, post} from './index'
import {aiapiUrl} from '@/config/url'

// 发送短信验证码
export const sendCheckCode = data => post(URL.sendCheckCode, data)
// 手机号验证码登录
export const commonLogin = data => post(URL.commonLogin, data)
// 获取用户信息
export const getUserInfo = data => get(`${URL.getUserInfo}${data.wechatId}`, data)
// 字典
export const getAllDicts = data => get(URL.getAllDicts, data)
// 广告位
export const getAdvertPush = data => get(URL.getAdvertPush, data)
// 获取默认商务年会活动
export const getAnnualMeeting = data => get(URL.getAnnualMeeting, data)
// 新增报名
export const addAnnualMeeting = data => post(URL.addAnnualMeeting, data)
// 我的报名列表
export const getMySignupList = data => get(URL.getMySignupList, data)
// 获取报名详情
export const getAnnualMeetingInfo = data => get(URL.getAnnualMeetingInfo, data)
// 报名修改
export const updateAnnualMeeting = data => post(URL.updateAnnualMeeting, data)
// 报名删除
export const deleteAnnualMeeting = data => get(URL.deleteAnnualMeeting, data)
// 年会到达信息图片识别
export const arrivalOcr = data =>
  post(URL.arrivalOcr, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })

// 我的签到列表
export const getAnnualMeetingSignin = data => get(URL.getAnnualMeetingSignin, data)
// 签到
export const addAnnualMeetingSign = data => post(URL.addAnnualMeetingSign, data)
// 签到记录
export const getAnnualMeetingSigninPagelist = data => get(URL.getAnnualMeetingSigninPagelist, data)

// 微信签名
export const getWxSign = data => get(URL.getWxSign, data)

// 获取直播主题分类
export const getPhotoType = data => get(URL.getPhotoType, data)
// 获取直播图片
export const getPhotoList = data => get(URL.getPhotoList, data)
// 获取直播图片详情
export const getPhotoInfo = data => get(URL.getPhotoInfo, data, {hideLoading: true})
// 人脸搜索接口
export const searchFace = data =>
  post(URL.searchFace, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })

// 勋章列表
export const getAnnualMeetingBadgeList = data => get(URL.getAnnualMeetingBadgeList, data)
// 勋章领取接口
export const addAnnualMeetingBadge = data => post(URL.addAnnualMeetingBadge, data)
// 用户核销码
export const getAnnualMeetingBadgeInfo = data => get(URL.getAnnualMeetingBadgeInfo, data)
// 工作人员核销
export const writeOff = data => post(URL.writeOff, data)

// 上传时光足迹照片
export const upload = data =>
  post(URL.upload, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
// 上传时光足迹照片
export const addAnnualMeetingFootprintPhoto = data => post(URL.addAnnualMeetingFootprintPhoto, data)
// 个人时光足迹列表
export const getAnnualMeetingFootprintPhotoList = data => get(URL.getAnnualMeetingFootprintPhotoList, data)

// 获取问卷
export const getMeetingSign = data => post(URL.getMeetingSign, data, {baseURL: aiapiUrl})
// 提交答案
export const signAnswer = data => post(URL.signAnswer, data, {baseURL: aiapiUrl})
// 统计
export const getMeetingSignSummary = data => post(URL.getMeetingSignSummary, data, {baseURL: aiapiUrl})

//
export const addAdvertClick = data => post(URL.addAdvertClick, data)
//
export const getAdvertClickList = data => get(URL.getAdvertClickList, data)
// 获取文章详情
export const getArticleInfo = data => get(`${URL.getArticleInfo}${data.id}`, {})
// 紧急联系人
export const getChargePhone = data => get(URL.getChargePhone, data)

// 新增司机招募令
export const addDriverRecruit = data => post(URL.addDriverRecruit, data)
